import type {
  Currency,
  PEPHIOOptions,
  TournamentHistoryRequestType,
  UpdateAccountDetailsAction
} from '@ps/web-core-enums';
import type {
  AccountHistoryStatementRequest,
  AccountLocales,
  AccountPayload,
  CasinoGameHistoryPayload,
  HandHistoryPayload,
  LugasPlayerStatusState,
  Response
} from '@ps/web-core-store';
import { models } from '@ps/web-core-store';

import type { EffectParams } from '@swf/core/store';

interface CoreAccountEffects {
  fetch(_payload: void, params: EffectParams): Promise<void>;
  requestHandHistory(payload: HandHistoryPayload, params: EffectParams): Promise<Response>;
  requestCasinoHandHistory(
    payload: CasinoGameHistoryPayload,
    params: EffectParams
  ): Promise<Response>;
  requestPlayingHistory(
    payload: {
      from: string;
      to: string;
      zipPassword: string;
      includeFpp: boolean;
      reportFormat: string;
      password?: string;
    },
    params: EffectParams
  ): Promise<Response>;
  requestTournamentHistory(
    payload: { type: TournamentHistoryRequestType; tournamentId: string },
    params: EffectParams
  ): Promise<Response>;
  updateAccount(
    { fetchAccount, ...payload }: AccountPayload,
    params: EffectParams
  ): Promise<Response>;
  updatePEPHIOSelection(
    payload: { pepHioSelection: PEPHIOOptions; rmf: boolean },
    params: EffectParams
  ): Promise<Response>;
  confirmAccountDetails(
    payload: { action: UpdateAccountDetailsAction },
    params: EffectParams
  ): Promise<Response>;
  updatePokerTimeLimit(
    payload: { amount: number; currency: Currency; type: number; passwordRequired: boolean },
    params: EffectParams
  ): Promise<Response>;
  mobileVerificationCode(payload: { code: number }, params: EffectParams): Promise<Response>;
  resendVerificationCode(_payload: void, params: EffectParams): Promise<Response>;
  validateEmailCode(payload: { code: number }, params: EffectParams): Promise<Response>;
  sendValidationEmail(_payload: void, params: EffectParams): Promise<unknown>;
  validateEmail(
    payload: { locale: string; site: string; country: string; signature: string; message: string },
    params: EffectParams
  ): Promise<Response>;
  updateEmailLocaleSettings(settings: AccountLocales, params: EffectParams): Promise<Response>;
  updatePassword(
    payload: { password: string; oldPassword: string },
    params: EffectParams
  ): Promise<Response>;
  updatePasswordReminderFlag(
    payload: { pwdReminder: boolean },
    params: EffectParams
  ): Promise<Response>;
  updatePlayChips(_payload: void, params: EffectParams): Promise<void>;
  requestAccountHistoryStatement(
    payload: AccountHistoryStatementRequest,
    params: EffectParams
  ): Promise<Response>;
  getLugasStatus(
    _payload: void,
    { request, dispatch }: EffectParams
  ): Promise<LugasPlayerStatusState>;
  sendLugasLongSessionAcknowledgment(
    _payload: void,
    { request, dispatch }: EffectParams
  ): Promise<void>;
  checkZipPassword(payload: { password: string }, params: EffectParams): Promise<Response>;
}

// cast to make CoreAccountEffects compatible with SW
const effects = {
  ...(models.account.effects as unknown as CoreAccountEffects)
};

export default effects;
